const React = require('react')

function XMarkIcon(props) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        xmlns: 'http://www.w3.org/2000/svg',
        viewBox: '0 0 20 20',
        fill: 'currentColor'
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M15.4248757,15.4230443 C15.6738991,15.1666967 15.6738991,14.7492162 15.4248757,14.5001928 L10.7373757,9.80536856 L15.4248757,5.11786856 C15.6738991,4.86884512 15.6812233,4.44404043 15.4248757,4.19501699 C15.168528,3.93866934 14.7437233,3.93866934 14.4946999,4.19501699 L9.80719989,8.88251699 L5.11969989,4.19501699 C4.87067645,3.93866934 4.43854755,3.93134512 4.18952411,4.19501699 C3.94050067,4.45136465 3.94050067,4.86884512 4.18952411,5.11786856 L8.87702411,9.80536856 L4.18952411,14.5001928 C3.94050067,14.7492162 3.93317645,15.1740209 4.18952411,15.4230443 C4.44587177,15.6720678 4.87067645,15.6720678 5.11969989,15.4230443 L9.80719989,10.7355443 L14.4946999,15.4230443 C14.7437233,15.6720678 15.1758522,15.679392 15.4248757,15.4230443 Z'
    })
  )
}

module.exports = XMarkIcon
